<template>
  <form class="w-full" @submit.prevent>
    <div class="w-full mb-4">
      <nx-input
        v-model="title"
        :errors="form.errors"
        id="title"
        type="text"
        label="Title"
        maxlength="100"
        :focus="true"
      />
    </div>

    <div class="mb-2">
      <nx-richtextarea v-model="body" :errors="form.errors" id="body" class="thread-create" />
    </div>

    <div class="w-full flex items-center">
      <div class="flex-1 pl-1">
        <nx-button
          type="primary"
          :disabled="loading"
          @click="submit"
        >{{ loading ? 'Loading..' : 'Submit' }}</nx-button>
      </div>
      <div class="text-right text-sm pr-1">
        <a
          class="cursor-pointer no-underline text-blue-8 hover:text-blue-9 | keyboard-shortcuts"
          @click="show.shortcuts = true"
        >Keyboard Shortcuts</a>
      </div>
    </div>

    <portal to="modal-portal">
      <rich-text-shortcuts-modal v-if="show.shortcuts" @close="show.shortcuts = false"></rich-text-shortcuts-modal>
    </portal>
  </form>
</template>

<script>
import Form from "form-backend-validation"
import RichTextShortcutsModal from "@/components/Modals/RichTextShortcutsModal"

export default {
  name: "ThreadCreateForm",
  components: {
    RichTextShortcutsModal
  },
  data() {
    return {
      form: new Form(),
      loading: false,
      title: "",
      body: "",
      show: {
        shortcuts: false
      }
    }
  },
  methods: {
    submit() {
      this.$api.threads
        .create({
          title: this.title,
          body: this.body
        })
        .then(({ data }) => {
          this.$router.push({
            name: "threads.show",
            params: {
              channel: this.$route.params.channel,
              thread: data.slug
            }
          })
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else if (data.response && data.response.status === 429) {
            this.$error.generic()
          }
        })
    }
  }
}
</script>
